/* 劉備傳・第 1 章：安喜（中山國，184 年後）
 * 小縣城安喜在中間，城裡有督郵住的傳舍（圍牆，南面有門）；城外四周還有黃巾殘部的小營地。 */
export const TOWN = [4000, 2400], LODGE = { x: 4000, y: 2150, hw: 320, hh: 220 }, CAMPS = [[1500, 1300], [1400, 3700], [6600, 1200], [6700, 3600]], EXIT = [7600, 2400];
const T = 26, N = LODGE.y - LODGE.hh, S = LODGE.y + LODGE.hh, Wx = LODGE.x - LODGE.hw, E = LODGE.x + LODGE.hw;
export const LODGE_GATE = [LODGE.x, S];
export default {
  id: 'anxi', name: '安喜', W: 8000, H: 4800, seed: 1841,
  bases: [[2800, 2500], EXIT],
  walls: [[LODGE.x, N, LODGE.hw + T, T], [Wx, LODGE.y, T, LODGE.hh], [E, LODGE.y, T, LODGE.hh], [(Wx + LODGE.x - 90) / 2, S, (LODGE.x - 90 - Wx) / 2 + T, T], [(LODGE.x + 90 + E) / 2, S, (E - LODGE.x - 90) / 2 + T, T]],
  roads: [{ pts: [[800, 2400], [2800, 2500], [TOWN[0], 2650], [5200, 2500], EXIT], w: 140 }, { pts: [[2800, 2500], CAMPS[0]], w: 100 }, { pts: [[2800, 2500], CAMPS[1]], w: 100 }, { pts: [[5200, 2500], CAMPS[2]], w: 100 }, { pts: [[5200, 2500], CAMPS[3]], w: 100 }],
  rocks: [[2600, 1000, 360, 170], [5400, 4000, 380, 180], [3000, 4100, 360, 170], [5600, 900, 360, 170]],
  woods: 0.4,
  sight: 0.8,
  clearings: [[TOWN[0], TOWN[1], 900], [2800, 2500, 400], ...CAMPS.map(([x, y]) => [x, y, 340])],
  villages: [{ x: TOWN[0], y: TOWN[1] + 350, n: 10, r: 600 }],
  shops: [[3500, 2800]],
  tents: CAMPS.map(([x, y]) => ({ x, y, n: 3, r: 220 })).concat([{ x: 2800, y: 2500, n: 3, r: 240, col: '#3e7b50', flag: '劉' }]),
  fields: [[2600, 3300, 560, 260], [5400, 1800, 520, 260, '#86803f']],
};
